import styled from 'styled-components';
import {
    space,
    typography,
    width,
    SpaceProps,
    TypographyProps,
    WidthProps,
    display,
    DisplayProps,
    overflow,
    OverflowProps,
} from 'styled-system';
import { color, ColorProps } from '../utils/styled-components/styledSystem';
import { textOverflow, TextOverflowProps } from '../utils/styled-components/textOverflow';
import { whiteSpace, WhiteSpaceProps } from '../utils/styled-components/whiteSpace';
import { overflowWrap, OverflowWrapProps } from '../utils/styled-components/overflowWrap';
import { fontFamily, FontFamilyProps } from '../utils/styled-components/fontFamily';
import { fontWeight, FontWeightProps } from '../utils/styled-components/fontWeight';
import { textDecoration, TextDecorationProps } from '../utils/styled-components/textDecoration';

export type InlineTextProps = ColorProps &
    SpaceProps &
    TypographyProps &
    WidthProps &
    OverflowProps &
    DisplayProps &
    TextOverflowProps &
    WhiteSpaceProps &
    OverflowWrapProps &
    FontWeightProps &
    FontFamilyProps &
    TextDecorationProps;

export const InlineText = styled.span<InlineTextProps>`
    text-decoration: inherit;
    ${({ overflowWrap }) => overflowWrap && `overflow-wrap: ${overflowWrap};`}
    ${overflow}
    ${space}
    ${width}
    ${typography}
    ${color}
    ${display}
    ${textOverflow}
    ${whiteSpace}
    ${overflowWrap}
    ${fontFamily}
    ${fontWeight}
    ${textDecoration}
`;

InlineText.displayName = 'InlineText';

InlineText.defaultProps = {
    textColor: 'inherit',
    margin: '0',
    padding: '0',
    display: 'inline-block',
    fontWeight: '400',
};
